import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-up-right",
  "use": "icon-arrow-up-right-usage",
  "viewBox": "0 0 31.213 31.213",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31.213 31.213\" id=\"icon-arrow-up-right\"><defs><style>#icon-arrow-up-right .a{fill:none;stroke:#f03748;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}</style></defs><g transform=\"translate(15.607 -9.849) rotate(45)\"><path class=\"a\" d=\"M10.5,25.5l15-15\" /><path class=\"a\" d=\"M10.5,10.5h15v15\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol